import { render, staticRenderFns } from "./NutritionModal.vue?vue&type=template&id=66d8cfba"
import script from "./NutritionModal.vue?vue&type=script&lang=js"
export * from "./NutritionModal.vue?vue&type=script&lang=js"
import style0 from "./NutritionModal.vue?vue&type=style&index=0&id=66d8cfba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports